import { render, staticRenderFns } from "./PersonRegister.vue?vue&type=template&id=2d6fd661&scoped=true&"
import script from "./PersonRegister.vue?vue&type=script&lang=js&"
export * from "./PersonRegister.vue?vue&type=script&lang=js&"
import style0 from "./PersonRegister.vue?vue&type=style&index=0&id=2d6fd661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6fd661",
  null
  
)

export default component.exports